import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ConnectedContactFlow from '@ignitesales/neuro-application/src/neuro-guide/components/ContactFlow/ConnectedContactFlow';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { FormattedHTMLMessage } from 'react-intl';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { notifySuccess } from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import useNeuroState, { sendResultsViaEmail, triggerIgniteAction, useDispatch } from '@ignitesales/neuro-application/src/neuro-guide/state';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';

const ContactFormModal = ({ className, closeBtn, isOpen, onClose, onComplete, selectedProduct, ...rest }) => {
  const messageContext = useNeuroMessages();
  const dispatch = useDispatch();
  const classes = classnames(className, 'contactFormModal');
  const contactFormHeader = messageContext.getMessage('contactMeForm.header');
  const contactUsHeader = messageContext.getMessage('contactMeForm.contactUsHeader');
  const contactUsMessage = messageContext.getMessage('contactMeForm.contactUs');
  const contactLoanTeamMessage = messageContext.getMessage('contactMeForm.contactLoanTeam');

  let contactFormInstructions = "contactFormInstructions";

  switch(selectedProduct.productAction){
    case "1": contactFormInstructions = 'contactMeForm.openAccount'; break;
    case "2": contactFormInstructions = 'contactMeForm.scheduleAccount'; break;
    case "3": contactFormInstructions = 'contactMeForm.applyAccount'; break;
    case "4": contactFormInstructions = 'contactMeForm.scheduleAccount'; break;
  }

  // success form message will live here
  const onEmailSent = ({lead}) => {
    onClose();
    onComplete(lead);
    notifySuccess('toast.sucessSubmit');
  };

  useEffect(() => {
    isOpen && dispatch(triggerIgniteAction({ actionName: 'contactMeClicked', value: 'started' }));
  }, [isOpen]);

  const successHeader = contactFormHeader;
  const successMessage = contactFormInstructions; //selectedProduct.productAction == '4' ? contactLoanTeamMessage : selectedProduct.productAction == '5' ? contactUsMessage : openAccountMessage;

  return (
    <Modal
      show={isOpen}
      className={classes}
      title={ successHeader }
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >
      <div className="shareResults">
        <FormattedHTMLMessage id={ 'contactMeForm.subtext.default' } tagName='div' />
      </div>
      <ConnectedContactFlow onComplete={onEmailSent} {...rest} />
    </Modal>
  );
};
ContactFormModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ContactFormModal;